import React, { memo } from 'react';
import Grid from 'layout/molecules/Grid/Grid';
function Shipments() {
    return (React.createElement(Grid, { gap: 0, hp: 24, vp: 16 },
        React.createElement("p", null, "Shipments")));
}
export default memo(Shipments);
